import React, { useCallback, useEffect, useState, useSyncExternalStore } from 'react';
import LoadingScreen from '../../../../../shared/LogoLoader/LoadingScreen';
import { useLocale } from '../../hooks';
import {
  completeFirstLoad,
  getFirstLoadHoldCount,
  isFirstLoadComplete,
  subscribeToFirstLoadHolds
} from '../../hooks/useFirstLoadHold';
import loaderMessages from '../LogoLoader/messages';

// Holds can drop to zero for a moment between steps (a route chunk resolving before
// the page registers its own loading state), so wait briefly before revealing.
const SETTLE_MS = 100;
// Never keep the portal covered longer than this after it appears, even if something is
// still loading; the page's own inline loading states take over from there. The loader's
// second phrase is fully in 4.8s after the screen appears (4s loop + 0.2s start + letter
// stagger and float), so this leaves it 1.7s to be read, and releases before it fades.
const MAX_SHOWN_MS = 6500;

const FirstLoadScreen = () => {
  const { messages } = useLocale(loaderMessages);
  const holdCount = useSyncExternalStore(subscribeToFirstLoadHolds, getFirstLoadHoldCount, getFirstLoadHoldCount);
  const [active, setActive] = useState(() => !isFirstLoadComplete());

  const finish = useCallback(() => {
    completeFirstLoad();
    setActive(false);
  }, []);

  useEffect(() => {
    if (!active || holdCount > 0) return undefined;

    const timeoutId = setTimeout(finish, SETTLE_MS);
    return () => clearTimeout(timeoutId);
  }, [active, holdCount, finish]);

  return (
    <LoadingScreen
      active={active}
      label={messages.loading}
      phrases={messages.phrases}
      maxShownMs={MAX_SHOWN_MS}
      onMaxShown={finish}
    />
  );
};

export default FirstLoadScreen;
